export default __webpack_public_path__ + "logo.6bbd252f.png";